// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__37Cy2","addWidgetButton":"Header_addWidgetButton__BxA9m","dashboardTabs":"Header_dashboardTabs__u7Pfk","active":"Header_active__1aAWm"};